import React, { Component } from 'react';
import Typeahead from '../typeahead/typeahead';
import { connect } from 'react-redux';
import { setFlightsFilters } from '../../actions/flight-list';

class FlightListFilters extends Component {
    constructor(props) {
        super(props);
        this.state = {};
        this.onChangeFilter = this.onChangeFilter.bind(this);
    }

    onChangeFilter(el) {
        let filters = { [el.name]: el.value };
        this.props.setFlightsFilters(filters);
    }

    render() {
        let keys = this.props.filters.map(({ key }) => key);

        let options = keys.reduce((memo, key) => {
            memo[key] = new Set();
            return memo;
        }, {});

        this.props.flights && this.props.flights.forEach(flight => {
            keys.forEach(key => {
                if (flight[key]) {
                    options[key].add(flight[key]);
                }
            });
        });

        let filters = this.props.filters.map(({ key, value, label, readonly }) =>
        <>
            <div className='col' key={key}>
                <Typeahead
                    name={key}
                    label={label}
                    options={[...options[key]]}
                    value={value}
                    readonly={readonly}
                    onChange={this.onChangeFilter} />
            </div>
            
            {/* <WorkAllocation options={[...options[key]]}  isLoaded={[...options[key]]} /> */}
            </>
        );
        console.log("state", this.props.state)

        return (
            <>
                {filters}
            </>
        );
    }
}

const mapStateToProps = state => ({
    flights: state.flights.data,
    filters: state.flights.filters,
    state: state
});

const mapActionsToProps = {
    setFlightsFilters,
};

export default connect(mapStateToProps, mapActionsToProps)(FlightListFilters);